import type { User } from '@/types/user';

import type { CreateUserErrorData } from './getCreateUserError';

// Event names mirror Sparta's so existing PostHog dashboards / funnels line up.
// Payloads are authored in camelCase; the PostHog layer decamelizes them to the
// snake_case keys Sparta established (see analytics/libs/posthog).
export const ACCOUNT_CREATED_EVENT = 'account-created';
export const SSO_ACCOUNT_CONFIRMED_EVENT = 'sso-account-confirmed';

/** PostHog payload for a successful non-SSO signup (Sparta `account-created`). */
export const accountCreatedEvent = (user: User) => ({
  uuid: user.uuid,
  teamCode: user.customerProfile.soloTeamCode,
  isTester: user.isTester,
});

/**
 * PostHog payload for account confirmation via profile update (Sparta
 * `sso-account-confirmed`). Sparta sends uuid + teamCode + isTester
 * (updateCustomerProfileEpic), so we match all three to keep funnel/dashboard
 * parity — sending only isTester broke that.
 */
export const ssoAccountConfirmedEvent = (user: User) => ({
  uuid: user.uuid,
  teamCode: user.customerProfile.soloTeamCode,
  isTester: user.isTester,
});

/**
 * Context for a create-user failure log (Sparta's `logErrorMessage('create user
 * error', …)`). Goes to Datadog Logs (camelCase, not decamelized). `isTester` is
 * omitted — the failure path has no user object, and onboarding doesn't carry
 * Sparta's email-based tester heuristic.
 */
export const createUserErrorContext = (error: CreateUserErrorData | undefined) => ({
  explanationCode: error?.code,
  maskedEmail: error?.maskedEmail,
});
